<template>
  <div>
    <i-col span="24" v-if="odd == '11'">
      <div v-for="(it , index) in tb1" :key="index+'tt1'">
        <table
          v-for="(item, key) in it"
          :key="key+'tc1'"
          class="left TB_COLLAPSE"
          :class="[cloce]"
          width="16.6%"
        >
          <thead>
            <th v-if="index == 0 && key < 6">生肖中</th>
            <th v-if="index == 1 && key < 6">生肖不中</th>
            <th v-if="index == 2 && key < 6">尾數</th>
            <th v-if="index == 3 && key < 6 ">一肖量</th>
            <th v-if="key < 6">賠率占成</th>
          </thead>
          <tbody>
            <tr class="tc" :class="[checkRankingColor(tb1sortItems, item, index)]">
              <th :class="item.colour">
                <h4>{{ item.name }}</h4>
              </th>
              <td width="60%" :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
                <table-adjust-odds :table="item" @go_live_show_bridge="go_live_show_bridge"></table-adjust-odds>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </i-col>
    <i-col span="24" v-if="odd == '47'">
      <table
        v-for="(it, index ) in tb2"
        :key="index+'tt2'"
        class="left TB_COLLAPSE"
        :class="[cloce]"
        width="20%"
      >
        <thead>
          <th>{{tableHead[index]}}</th>
          <th>賠率占成</th>
        </thead>
        <tbody>
          <tr
            class="tc"
            v-for="(item, key) in it"
            :key="key+'tc2'"
            :class="[checkRankingColor(tb2sortItems, item, index)]"
          >
            <th :class="item.colour">
              <h4>{{ item.name }}</h4>
            </th>
            <td width="60%" :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
              <table-adjust-odds :table="item" @go_live_show_bridge="go_live_show_bridge"></table-adjust-odds>
            </td>
          </tr>
        </tbody>
      </table>
    </i-col>
  </div>
</template>

<script>
import { Utile } from "utils";
import { mapGetters, mapState, mapActions } from "vuex";
import checkpath from "./mixins/checkPath.js";
import liveshowSixmark from '@/mixins/liveshow-sixmark.js'
export default {
  name: "liveshow-rawtail",
  mixins: [checkpath, liveshowSixmark],
  data () {
    return {
      tb1: [],
      tb2: [],
      tableHead: ['一肖量', '1肖数', '2肖数', '3肖数', '4肖数', '5肖数'],
      page: "",
      odd: "",
      zodiac: []
    };
  },
  computed: {
    ...mapGetters(["getliveshow", "getgameid"]),
    KeyName () {
      return this.liveshowPath ? "supodod" : "linksupodod";
    },
    tb1sortItems () {
      if (!this.tb1.length) return []
      return this.tb1.slice().map(it => it.slice().sort((a, b) => b.ltl - a.ltl).slice(0, 3).map(it => `${it.odddtl}-${it.troddid}`))
    },
    tb2sortItems () {
      if (!this.tb2.length) return []
      return this.tb2.slice().map(it => it.slice().sort((a, b) => b.ltl - a.ltl).slice(0, 3).map(it => `${it.odddtl}-${it.troddid}`))
    },
  },
  watch: {
    "getliveshow.chgbaco" (val) {
      this.chgbacofun();
    },
    "$route.query.odd" (val) {
      this.readyaxiso();
    }
  },
  created () {
    this.getNowZodiac()
    this.readyaxiso();
  },
  methods: {
    async getNowZodiac () {
      try {
        const res = await this.$axios.setting.getNowZodiac()
        if ('status' in res && res.status === 0) return
        this.zodiac = res
      } catch (err) {
        console.log(err);
      }
    },
    checkRankingColor (items, val, key) {
      if (!items.length || this.getBettingStatus == 0) return
      const state = items[key].some(it => it == `${val.odddtl}-${val.troddid}`)
      return { 'ranking-top': state }
    },
    chgbacofun () {
      this.get_tb1(this.getliveshow.chgbaco);
    },
    async get_tb1 (baco) {
      try {
        const obj = {
          gameid: this.getgameid,
          page: this.page,
          odd: this.odd,
          baco: baco,
          site: this.getliveshow.siteSelect
        }
        if (this.getliveshow.siteSelect == '') {
          this.tb1 = []
          this.tb2 = []
          return
        }
        const res = await this.$axios.liveshow[this.KeyName](obj);
        if ('status' in res && res.status === 0) return
        this.IsstopColor(res)
        const array = res.map(it => (it.clas = 0, it));
        if (this.odd == 11) {
          const data = array.filter(it => it.odddtl < 77 || it.odddtl == 85)
          this.tb1 = Utile.chunk(data, 12);
          let changeArry = this.tb1[2].splice(10, 1)
          this.tb1[2].splice(5, 0, changeArry[0])
        } else {
          const nowYear = Number(this.zodiac[0].id) + 47
          const cut = [[0, 12], [12, 24], [24, 36], [36, 48], [nowYear, nowYear + 1]];
          const data = array.filter(it => it.odddtl >= 77 && it.odddtl <= 81)
          this.tb2 = cut.map((it, index) => data.slice(...it));
        }
      } catch (error) {
        console.log(error);
        this.$Message.error("网路异常：(S3009)");
      }
    },
    readyaxiso () {
      if (this.$route.query.page) {
        this.page = this.$route.query.page;
        this.odd = this.$route.query.odd;
      } else {
        this.page = this.$route.meta.page;
        this.odd = this.$route.meta.odd;
      }
      if (!this.$route.name.includes('rawtail')) return
      this.chgbacofun();
    },
    go_live_show_bridge () {
      this.$emit("refresh");
    }
  }
};
</script>